import { render, staticRenderFns } from "./imgV.vue?vue&type=template&id=7813076f"
var script = {}
import style0 from "./imgV.vue?vue&type=style&index=0&id=7813076f&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7813076f')) {
      api.createRecord('7813076f', component.options)
    } else {
      api.reload('7813076f', component.options)
    }
    module.hot.accept("./imgV.vue?vue&type=template&id=7813076f", function () {
      api.rerender('7813076f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgV.vue"
export default component.exports